import { Link } from "gatsby"
import React from "react"
import { gtmTracking } from "@/utils/gtm-tracking"

const QuoteLarge = ({
  quote,
  cite,
  className = "",
  inline = "false",
  footerLink,
}) => {
  const setCitation = () => {
    if (cite.link) {
      if (cite.link.includes("https://")) {
        return (
          <a
            href={cite.link}
            className="text-link text-link--bare p--sm"
            onClick={() =>
              gtmTracking("Link Click", cite.role_company, "Quote")()
            }
          >
            {cite.role_company}
          </a>
        )
      } else {
        return (
          <Link
            to={cite.link}
            className="text-link text-link--bare p--sm"
            onClick={() =>
              gtmTracking("Link Click", cite.role_company, "Quote")()
            }
          >
            {cite.role_company}
          </Link>
        )
      }
    }

    return <p className="p--sm">{cite.role_company}</p>
  }

  return (
    <div
      className={`container-fluid center-xs col-xs-12 col-md-8 mb-20 ${
        className ?? ""
      }`}
    >
      <hr className="divider w80 mb-10" />
      <blockquote>&quot;{quote}&quot;</blockquote>
      {inline.toLowerCase() === "true" ? (
        <p className="mt-4 p--lg">
          {cite.name} - {cite.role_company}
        </p>
      ) : (
        <p className="mt-4 p--lg">{cite.name}</p>
      )}
      <cite>{setCitation()}</cite>
      {footerLink && footerLink.url.includes("https://") ? (
        <a
          href={footerLink.url}
          className="btn btn--tertiary btn--sm p--sm mt-2"
          onClick={() => gtmTracking("CTA Click", footerLink.text, "Quote")()}
        >
          {footerLink.text}
        </a>
      ) : (
        footerLink && (
          <Link
            to={footerLink.url}
            className="btn btn--tertiary btn--sm p--sm mt-2"
            onClick={() => gtmTracking("CTA Click", footerLink.text, "Quote")()}
          >
            {footerLink.text}
          </Link>
        )
      )}
    </div>
  )
}

export default QuoteLarge
